import { render, staticRenderFns } from "./PuiTable.vue?vue&type=template&id=007fb90e&scoped=true&"
import script from "./PuiTable.vue?vue&type=script&lang=js&"
export * from "./PuiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007fb90e",
  null
  
)

export default component.exports